import { render } from "./BookingInformation.vue?vue&type=template&id=c575f2c6&scoped=true"
import script from "./BookingInformation.vue?vue&type=script&lang=js"
export * from "./BookingInformation.vue?vue&type=script&lang=js"

import "./BookingInformation.vue?vue&type=style&index=0&id=c575f2c6&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c575f2c6"]])

export default __exports__